class BlogLinkCard {
  constructor() {
    this.initCards();
  }

  async initCards() {
    const cardElements = document.querySelectorAll('[data-article-handle]');
    for (const element of cardElements) {
      const handle = element.getAttribute('data-article-handle');
      
      // プレースホルダーテキストを設定
      const articleName = element.getAttribute('data-article-name') || handle;
      const placeholderText = `┌────────────────────────────
│ ブログリンクカード 【記事】${articleName}
└────────────────────────────`;
      
      // テキストエディタ向けのプレースホルダーを設定
      if (!element.textContent) {
        element.textContent = placeholderText;
      }

      await this.fetchAndRenderCard(element, handle);
    }
  }

  async fetchAndRenderCard(element, handle) {
    try {
      const url = `/blogs/contents/${handle}`;
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const titleElement = doc.querySelector('h1.article-template__title, h1:not([class]), .article-template h1');
      const headTitle = doc.querySelector('title');
      const title = titleElement?.textContent?.trim() || 
                   headTitle?.textContent?.trim() || 
                   '記事が見つかりません';

      const image = doc.querySelector('meta[property="og:image"]')?.content;
      const excerpt = doc.querySelector('meta[property="og:description"]')?.content ||
                     doc.querySelector('meta[name="description"]')?.content ||
                     this.getExcerpt(doc);

      const isMobile = window.innerWidth <= 640;
      const excerptLength = isMobile ? 80 : 100;

      element.innerHTML = `
        <div class="re-blog-card">
          <div class="re-blog-card__label">あわせて読みたい</div>
          <a href="${url}" class="re-blog-card__link">
            <div class="re-blog-card__inner">
              ${image ? `
                <div class="re-blog-card__image">
                  <img src="${image}" alt="${this.encodeSpecialChars(title)}" loading="lazy">
                </div>
              ` : ''}
              <div class="re-blog-card__content">
                <h3 class="re-blog-card__title">${this.encodeSpecialChars(title)}</h3>
                <p class="re-blog-card__excerpt">${this.truncateText(excerpt || '', excerptLength)}</p>
              </div>
            </div>
          </a>
        </div>
      `;

      this.addStyles();

    } catch (error) {
      console.error('Error fetching article:', error);
      element.innerHTML = `
        <div class="re-blog-card--error">
          <p>記事の読み込みに失敗しました。</p>
        </div>
      `;
    }
  }


  addStyles() {
    if (!document.querySelector('#re-blog-card-styles')) {
      const styleSheet = document.createElement('style');
      styleSheet.id = 're-blog-card-styles';
      styleSheet.textContent = `
        .re-blog-card {
          position: relative !important;
          margin: 28px 0 12px !important;
          max-width: 600px !important;
          background: #fff !important;
        }

        .re-blog-card__label {
          position: absolute !important;
          top: -0.6em !important;
          left: 1em !important;
          display: inline-block !important;
          padding: 0.1em 1em 0.1em 2em !important;
          font-size: 12px !important;
          line-height: 1.6 !important;
          color: #444 !important;
          background: #fff !important;
          border: 1px solid #999 !important;
          border-radius: 4px !important;
          z-index: 2 !important;
        }

        .re-blog-card__label::before {
          content: "✓" !important;
          position: absolute !important;
          left: 0.8em !important;
          top: 50% !important;
          transform: translateY(-50%) !important;
          color: #3ea8ff !important;
          font-weight: bold !important;
          font-size: 12px !important;
        }

        .re-blog-card__link {
          display: block !important;
          text-decoration: none !important;
          background: #fff !important;
          position: relative !important;
        }

        .re-blog-card__inner {
          display: flex !important;
          align-items: flex-start !important;
          padding: 24px 16px 16px !important;
          gap: 20px !important;
          background: #fff !important;
          border: 1px solid #999 !important;
          margin-top: 1em !important;
        }

        .re-blog-card__image {
          width: 100px !important;
          height: 100px !important;
          flex-shrink: 0 !important;
          overflow: hidden !important;
        }

        .re-blog-card__image img {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover !important;
          display: block !important;
        }

        .re-blog-card__content {
          flex: 1 !important;
          min-width: 0 !important;
        }

        .re-blog-card__title {
          margin: 0 0 6px 0 !important;
          padding: 0 !important;
          font-size: 16px !important;
          font-weight: 600 !important;
          line-height: 1.4 !important;
          color: #333 !important;
          background: none !important;
          border: none !important;
        }

        .re-blog-card__excerpt {
          margin: 0 !important;
          padding: 0 !important;
          font-size: 12px !important;
          line-height: 1.5 !important;
          color: #666 !important;
          display: -webkit-box !important;
          -webkit-box-orient: vertical !important;
          -webkit-line-clamp: 3 !important;
          overflow: hidden !important;
          max-height: 4.5em !important;
          word-break: break-word !important;
        }

        .re-blog-card--error {
          padding: 8px !important;
          color: #666 !important;
          text-align: center !important;
          font-size: 12px !important;
        }

        @media (max-width: 640px) {
          .re-blog-card__title {
            font-size: 15px !important;
          }
          
          .re-blog-card__excerpt {
            font-size: 11px !important;
            line-height: 1.5 !important;
            -webkit-line-clamp: 3 !important;
            max-height: 4.5em !important;
          }

          .re-blog-card__inner {
            padding: 20px 14px 14px !important;
            gap: 16px !important;
          }

          .re-blog-card__image {
            width: 80px !important;
            height: 80px !important;
          }
        }
      `;
      document.head.appendChild(styleSheet);
    }
  }

  getExcerpt(doc) {
    const content = doc.querySelector('.article-template__content') ||
                   doc.querySelector('article') ||
                   doc.querySelector('.rte');
    return content ? content.textContent.trim().substring(0, 120) + '...' : '';
  }

  encodeSpecialChars(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  truncateText(text, length) {
    const strippedText = text.replace(/(<([^>]+)>)/gi, '').trim();
    return strippedText.length > length 
      ? strippedText.substring(0, length) + '...' 
      : strippedText;
  }
}

// ページ読み込み時に初期化
document.addEventListener('DOMContentLoaded', () => {
  new BlogLinkCard();
});